/* Garvelle · Welkomstspel met 3D-dobbelstenen
 * Geïsoleerd: alles zit in #g3d. Three.js wordt pas geladen als het spel start.
 * Uitkomst is vooraf bepaald (promotiespel) en wordt in de spelregels zo vermeld.
 */
(function () {
  'use strict';
  var root = document.getElementById('g3d');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-g3d-config]').textContent); } catch (e) { return; }

  var KEY = 'g3d_state_v1';
  var DAY = 864e5;
  var isEditor = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- opslag ---------- */
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  var st = load();
  function setState(patch) { for (var k in patch) st[k] = patch[k]; st.ts = Date.now(); save(st); }

  function suppressed() {
    if (cfg.test) return false;
    var age = Date.now() - (st.ts || 0);
    if (st.status === 'closed' && age < 7 * DAY) return true;
    if (st.status === 'done' && age < 30 * DAY) return true;
    return false;
  }

  /* ---------- elementen ---------- */
  var overlay = root.querySelector('.g3d');
  var dialog = root.querySelector('.g3d__dialog');
  var screens = {};
  root.querySelectorAll('[data-screen]').forEach(function (el) { screens[el.dataset.screen] = el; });
  var $ = function (sel) { return root.querySelector(sel); };

  function show(name) {
    for (var k in screens) screens[k].hidden = (k !== name);
    var focusEl = screens[name].querySelector('[data-autofocus]') || screens[name].querySelector('button, input');
    if (focusEl && !isTouch()) setTimeout(function () { focusEl.focus({ preventScroll: true }); }, 60);
  }
  function isTouch() { return window.matchMedia('(pointer: coarse)').matches; }

  /* ---------- openen / sluiten ---------- */
  var lastFocus = null, scrollY = 0;
  function lockScroll() {
    scrollY = window.scrollY || 0;
    document.documentElement.classList.add('g3d-lock');
    document.body.style.top = -scrollY + 'px';
  }
  function unlockScroll() {
    document.documentElement.classList.remove('g3d-lock');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }
  function open() {
    if (overlay.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    lockScroll();
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    resume();
    prefetchThree();
  }
  function close(reason) {
    overlay.classList.remove('is-open');
    setTimeout(function () { overlay.hidden = true; }, 320);
    unlockScroll();
    if (st.status !== 'done' && st.status !== 'playing') setState({ status: 'closed' });
    if (stage) stage.pause();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', function () { close('x'); }); });
  overlay.addEventListener('mousedown', function (e) { if (e.target === overlay) close('backdrop'); });
  document.addEventListener('keydown', function (e) {
    if (overlay.hidden) return;
    if (e.key === 'Escape') close('esc');
    if (e.key === 'Tab') trapFocus(e);
  });
  function trapFocus(e) {
    var f = Array.prototype.filter.call(dialog.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])'), function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- verloop hervatten (geen nieuwe codes door te verversen) ---------- */
  function resume() {
    if (st.status === 'done' && st.path) return showWin(st.path, true);
    if (st.status === 'playing') {
      if (st.path === '5') return startGame('5');
      if (st.path === '10' && st.step === 'form') return show('form');
      if (st.path === '10') return startGame('10');
    }
    show('intro');
  }

  /* ---------- keuze ---------- */
  root.querySelectorAll('[data-choose]').forEach(function (b) {
    b.addEventListener('click', function () {
      var path = b.dataset.choose;
      if (path === '5') { setState({ status: 'playing', path: '5', step: 'roll' }); startGame('5'); }
      else { setState({ status: 'playing', path: '10', step: 'form' }); show('form'); }
    });
  });
  var backBtn = $('[data-back]');
  if (backBtn) backBtn.addEventListener('click', function () { setState({ status: 'new', path: null, step: null }); show('intro'); });

  /* ---------- formulier ---------- */
  var form = $('.g3d__form');
  function normPhone(raw) {
    var v = String(raw || '').replace(/[\s\-().\/]/g, '');
    if (/^00/.test(v)) v = '+' + v.slice(2);
    var nl = v.match(/^(?:\+31|0)([1-9]\d{8})$/);
    if (nl) return '+31' + nl[1];
    var be = v.match(/^(?:\+32|0)(4\d{8}|[1-9]\d{7})$/);
    if (be) return '+32' + be[1];
    return null;
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim()); }
  function fieldError(input, msg) {
    var err = input.closest('.g3d__field').querySelector('.g3d__err');
    err.textContent = msg || '';
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }
  // fout direct wissen tijdens typen, zodat de layout niet verspringt bij het volgende tikje
  form.email.addEventListener('input', function () { if (validEmail(form.email.value)) fieldError(form.email, ''); });
  form.phone.addEventListener('input', function () { if (normPhone(form.phone.value)) fieldError(form.phone, ''); });
  form.email.addEventListener('blur', function () { if (form.email.value) fieldError(form.email, validEmail(form.email.value) ? '' : 'Vul een geldig e-mailadres in, bijvoorbeeld naam@voorbeeld.nl.'); });
  form.phone.addEventListener('blur', function () { if (form.phone.value) fieldError(form.phone, normPhone(form.phone.value) ? '' : 'Vul een geldig Nederlands of Belgisch telefoonnummer in, bijvoorbeeld 06 12345678.'); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = form.email.value.trim();
    var phone = normPhone(form.phone.value);
    var ok = true;
    if (!validEmail(email)) { fieldError(form.email, 'Vul een geldig e-mailadres in, bijvoorbeeld naam@voorbeeld.nl.'); ok = false; } else fieldError(form.email, '');
    if (!phone) { fieldError(form.phone, 'Vul een geldig Nederlands of Belgisch telefoonnummer in, bijvoorbeeld 06 12345678.'); ok = false; } else fieldError(form.phone, '');
    if (!ok) { (form.querySelector('[aria-invalid="true"]') || form.email).focus(); return; }
    var emailOk = form.consent_email.checked;
    var waOk = form.consent_whatsapp.checked;
    var btn = form.querySelector('[type="submit"]');
    btn.disabled = true;
    saveLead(email, phone, emailOk, waOk);
    setState({ status: 'playing', path: '10', step: 'roll1', lead: true });
    btn.disabled = false;
    startGame('10');
  });

  /* Shopify-native opslag, zonder API-sleutels in de browser.
   * - Met e-mailtoestemming: Shopify-klantformulier (maakt/actualiseert de klant, zet e-mailmarketing aan, voegt tags toe).
   * - Zonder e-mailtoestemming: het klantformulier zou de klant automatisch inschrijven. Daarom:
   *     mode "contact"  -> contactformulier naar de winkelinbox (klant wordt NIET ingeschreven)
   *     mode "customer" -> klantformulier + Shopify Flow die de inschrijving direct weer intrekt (zie handleiding)
   */
  function saveLead(email, phone, emailOk, waOk) {
    var tags = [cfg.tag || 'DICE_GAME_10', 'bron-welcome-dice-game', 'tel:' + phone,
      'email-toestemming-' + (emailOk ? 'ja' : 'nee'), 'whatsapp-toestemming-' + (waOk ? 'ja' : 'nee')];
    var fd = new FormData();
    fd.append('utf8', '✓');
    if (emailOk || cfg.noconsent_mode === 'customer') {
      fd.append('form_type', 'customer');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', tags.join(','));
    } else {
      fd.append('form_type', 'contact');
      fd.append('contact[email]', email);
      fd.append('contact[Telefoon]', phone);
      fd.append('contact[Bron]', 'Welcome Dice Game');
      fd.append('contact[Tags]', tags.join(', '));
      fd.append('contact[body]', 'Deelname welkomstspel (10%). Geen toestemming voor e-mailmarketing. WhatsApp-toestemming: ' + (waOk ? 'ja' : 'nee') + '.');
    }
    try {
      fetch(cfg.post_url || '/contact', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) { if (r.url && r.url.indexOf('challenge') > -1) setState({ leadChallenge: true }); })
        .catch(function () {});
    } catch (err) {}
    try { if (window.dataLayer) window.dataLayer.push({ event: 'g3d_lead', email_consent: emailOk, whatsapp_consent: waOk }); } catch (e) {}
  }

  /* ---------- spel ---------- */
  var stage = null, stagePromise = null, threeMod = null;
  var stageEl = $('.g3d__stage');
  var statusEl = $('[data-status]');
  var rollBtn = $('[data-roll]');
  var chanceEl = $('[data-chance]');

  function prefetchThree() {
    if (threeMod || !cfg.three) return;
    var l = document.createElement('link');
    l.rel = 'modulepreload'; l.href = cfg.three; l.crossOrigin = 'anonymous';
    document.head.appendChild(l);
  }
  function getStage() {
    if (stage) return Promise.resolve(stage);
    if (stagePromise) return stagePromise;
    stagePromise = import(cfg.three).then(function (THREE) {
      threeMod = THREE;
      stage = new Stage3D(THREE, stageEl);
      return stage;
    }).catch(function () {
      stage = new Stage2D(stageEl);
      return stage;
    });
    return stagePromise;
  }

  var attempt = 1;
  function startGame(path) {
    show('game');
    root.dataset.path = path;
    chanceEl.hidden = true;
    stageEl.classList.remove('is-dim', 'is-win');
    if (path === '5') {
      attempt = 2;
      statusEl.textContent = 'Daar gaan we! Gooi de dobbelstenen.';
      rollBtn.textContent = 'Gooi de dobbelstenen';
    } else {
      attempt = (st.step === 'roll2') ? 2 : 1;
      if (attempt === 1) { statusEl.textContent = 'Daar gaan we! Gooi de dobbelstenen.'; rollBtn.textContent = 'Gooi de dobbelstenen'; }
      else { secondChanceUI(); }
    }
    rollBtn.disabled = true;
    getStage().then(function (s) { s.resize(); s.idle(); rollBtn.disabled = false; });
  }

  function secondChanceUI() {
    statusEl.textContent = 'Dit is je laatste kans. Gooi nog één keer!';
    rollBtn.textContent = 'Gooi nog één keer';
    chanceEl.hidden = false;
  }

  rollBtn.addEventListener('click', function () {
    if (rollBtn.disabled) return;
    rollBtn.disabled = true;
    var path = root.dataset.path;
    var result;
    if (path === '5') result = pickWin5();
    else result = attempt === 1 ? pickLose() : [6, 6];
    statusEl.textContent = 'Rollen…';
    getStage().then(function (s) {
      s.roll(result).then(function () {
        if (path === '5') return finish('5');
        if (attempt === 1) {
          attempt = 2;
          setState({ step: 'roll2' });
          statusEl.textContent = 'Net niet! Maar je krijgt nog één kans…';
          stageEl.classList.add('is-dim');
          dialog.classList.add('g3d-shake');
          setTimeout(function () { dialog.classList.remove('g3d-shake'); }, 600);
          setTimeout(function () {
            stageEl.classList.remove('is-dim');
            secondChanceUI();
            rollBtn.disabled = false;
          }, 1500);
        } else {
          stageEl.classList.add('is-win'); chanceEl.hidden = true;
          statusEl.innerHTML = '<strong class="g3d__double">DUBBELE ZES!</strong>';
          confetti();
          setTimeout(function () { finish('10'); }, 1600);
        }
      });
    });
  });

  function pickLose() {
    var pairs = [[6, 5], [5, 6], [6, 4], [4, 6], [5, 5], [3, 6]];
    return pairs[Math.floor(Math.random() * pairs.length)];
  }
  function pickWin5() {
    var pairs = [[4, 1], [1, 4], [3, 2], [2, 3]]; // samen 5
    return pairs[Math.floor(Math.random() * pairs.length)];
  }

  function finish(path) {
    setState({ status: 'done', path: path, step: 'won' });
    showWin(path, false);
  }

  function showWin(path, resumed) {
    var code = path === '10' ? cfg.code10 : cfg.code5;
    var scr = screens['win'];
    scr.querySelector('[data-win-kicker]').textContent = path === '10' ? 'Jouw beloning staat klaar!' : 'Gefeliciteerd!';
    scr.querySelector('[data-win-title]').innerHTML = path === '10'
      ? 'GEFELICITEERD! Je hebt <em>10% korting</em> gewonnen!'
      : 'Je hebt <em>5% korting</em> gewonnen.';
    scr.querySelector('[data-win-text]').textContent = path === '10'
      ? 'Gebruik ' + code + ' en ontvang 10% korting op je bestelling.'
      : 'Gebruik de code ' + code + ' bij het afrekenen.';
    scr.querySelector('[data-code]').textContent = code;
    var shop = scr.querySelector('[data-shop]');
    shop.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cfg.shop_url || '/collections/all');
    show('win');
    if (!resumed && path === '5') confetti(60);
  }

  /* ---------- kopiëren ---------- */
  var copyBtn = $('[data-copy]');
  copyBtn.addEventListener('click', function () {
    var code = $('[data-code]').textContent.trim();
    var done = function () {
      copyBtn.classList.add('is-done');
      copyBtn.textContent = 'Gekopieerd ✓';
      $('[data-copied]').textContent = 'De code ' + code + ' staat op je klembord.';
      setTimeout(function () { copyBtn.classList.remove('is-done'); copyBtn.textContent = 'Kopieer kortingscode'; }, 2400);
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback);
    else fallback();
    function fallback() {
      var t = document.createElement('textarea');
      t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select(); t.setSelectionRange(0, 99);
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(t); done();
    }
  });
  var shopLink = $('[data-shop]');
  shopLink.addEventListener('click', function () { overlay.classList.remove('is-open'); unlockScroll(); });

  /* ---------- confetti (2D, licht) ---------- */
  function confetti(n) {
    var c = $('.g3d__confetti');
    if (!c || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r = dialog.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    c.width = r.width * dpr; c.height = r.height * dpr;
    var ctx = c.getContext('2d'); ctx.scale(dpr, dpr);
    var colors = ['#E6C7AE', '#F2EBDD', '#2F5B47', '#5F8A98', '#151614'];
    var parts = [];
    for (var i = 0; i < (n || 140); i++) parts.push({
      x: r.width / 2 + (Math.random() - .5) * 60, y: r.height * .38,
      vx: (Math.random() - .5) * 9, vy: -Math.random() * 9 - 3,
      w: 5 + Math.random() * 5, h: 3 + Math.random() * 4, a: Math.random() * 6, va: (Math.random() - .5) * .3,
      c: colors[i % colors.length]
    });
    var t0 = performance.now();
    (function tick(t) {
      var el = (t - t0) / 1000;
      ctx.clearRect(0, 0, r.width, r.height);
      parts.forEach(function (p) {
        p.vy += .28; p.vx *= .99; p.x += p.vx; p.y += p.vy; p.a += p.va;
        ctx.save(); ctx.globalAlpha = Math.max(0, 1 - el / 2.6); ctx.translate(p.x, p.y); ctx.rotate(p.a);
        ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); ctx.restore();
      });
      if (el < 2.6) requestAnimationFrame(tick); else ctx.clearRect(0, 0, r.width, r.height);
    })(t0);
  }

  /* ---------- 3D-podium (Three.js) ---------- */
  function Stage3D(THREE, el) {
    var self = this;
    this.T = THREE; this.el = el;
    var renderer = this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'low-power' });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    if ('outputColorSpace' in renderer) renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;
    el.appendChild(renderer.domElement);
    renderer.domElement.setAttribute('aria-hidden', 'true');

    var scene = this.scene = new THREE.Scene();
    var cam = this.cam = new THREE.PerspectiveCamera(32, 1, .1, 60);
    scene.add(new THREE.HemisphereLight(0xffffff, 0x8a9a8e, 1.15));
    var key = new THREE.DirectionalLight(0xffffff, 2.1);
    key.position.set(3.5, 9, 4.5); key.castShadow = true;
    key.shadow.mapSize.set(1024, 1024);
    var sc = key.shadow.camera; sc.left = -5; sc.right = 5; sc.top = 5; sc.bottom = -5; sc.near = 1; sc.far = 25;
    key.shadow.radius = 4; key.shadow.bias = -0.0005;
    scene.add(key);
    var rim = new THREE.DirectionalLight(0xe6c7ae, .55); rim.position.set(-5, 3, -4); scene.add(rim);

    var floor = new THREE.Mesh(new THREE.PlaneGeometry(30, 30), new THREE.ShadowMaterial({ opacity: .22 }));
    floor.rotation.x = -Math.PI / 2; floor.receiveShadow = true; scene.add(floor);

    var geo = roundedBox(THREE, 1, .16, 6);
    this.dice = [
      makeDie(THREE, geo, '#F7F5EF', '#151614'),
      makeDie(THREE, geo, '#24443A', '#F2EBDD')
    ];
    this.dice.forEach(function (d) { scene.add(d); });
    this.dice[0].position.set(-.8, .5, .2);
    this.dice[1].position.set(.8, .5, -.1);
    this.dice[0].quaternion.copy(faceQuat(THREE, 1, .5));
    this.dice[1].quaternion.copy(faceQuat(THREE, 3, -.4));

    this.anim = null;
    this.resize = function () {
      var w = el.clientWidth || 300, h = el.clientHeight || 220;
      renderer.setSize(w, h, false);
      cam.aspect = w / h;
      var far = cam.aspect < 1.2 ? 9.6 : 8;
      cam.position.set(0, far * .78, far * .62);
      cam.lookAt(0, 0, .15);
      cam.updateProjectionMatrix();
      renderer.render(scene, cam);
    };
    window.addEventListener('resize', function () { if (!overlay.hidden) self.resize(); });
    this.idle = function () { renderer.render(scene, cam); };
    this.pause = function () { if (self.raf) cancelAnimationFrame(self.raf); self.raf = null; };

    this.roll = function (values) {
      return new Promise(function (resolve) {
        var D = 1750;
        var specs = self.dice.map(function (die, i) {
          var side = i === 0 ? -1 : 1;
          var axis = new THREE.Vector3(Math.random() - .5, Math.random() * .6 + .2, Math.random() - .5).normalize();
          return {
            die: die,
            from: new THREE.Vector3(-3.6 + Math.random() * .4, 2.6 + Math.random() * .6, (i ? -1 : 1) * (.6 + Math.random() * .5)),
            to: new THREE.Vector3(side * (.72 + Math.random() * .12), .5, (i ? -.15 : .25) + (Math.random() - .5) * .25),
            axis: axis,
            spins: (5 + Math.random() * 3) * Math.PI,
            q0: new THREE.Quaternion().setFromEuler(new THREE.Euler(Math.random() * 6, Math.random() * 6, Math.random() * 6)),
            target: faceQuat(THREE, values[i], (Math.random() - .5) * 1.2),
            delay: i * 90,
            h: 1.9 + Math.random() * .5
          };
        });
        var t0 = performance.now();
        var tmpQ = new THREE.Quaternion();
        function frame(now) {
          var allDone = true;
          specs.forEach(function (s) {
            var t = Math.min(1, Math.max(0, (now - t0 - s.delay) / D));
            if (t < 1) allDone = false;
            var e = 1 - Math.pow(1 - t, 3);
            s.die.position.x = s.from.x + (s.to.x - s.from.x) * e;
            s.die.position.z = s.from.z + (s.to.z - s.from.z) * e;
            var bounce = Math.abs(Math.cos(3 * Math.PI * Math.min(1, t * 1.08))) * s.h * Math.pow(1 - t, 1.7);
            s.die.position.y = .5 + bounce;
            tmpQ.setFromAxisAngle(s.axis, s.spins * e);
            var spinQ = tmpQ.clone().multiply(s.q0);
            var k = smooth(.5, 1, t);
            s.die.quaternion.copy(spinQ).slerp(s.target, k);
          });
          renderer.render(scene, cam);
          if (!allDone) self.raf = requestAnimationFrame(frame);
          else { self.raf = null; resolve(); }
        }
        self.raf = requestAnimationFrame(frame);
      });
    };
  }
  function smooth(a, b, x) { var t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); }

  function roundedBox(THREE, size, r, seg) {
    var g = new THREE.BoxGeometry(size, size, size, seg, seg, seg);
    var p = g.attributes.position, n = g.attributes.normal;
    var inner = size / 2 - r, v = new THREE.Vector3(), c = new THREE.Vector3(), d = new THREE.Vector3();
    for (var i = 0; i < p.count; i++) {
      v.fromBufferAttribute(p, i);
      c.set(Math.max(-inner, Math.min(inner, v.x)), Math.max(-inner, Math.min(inner, v.y)), Math.max(-inner, Math.min(inner, v.z)));
      d.subVectors(v, c).normalize();
      v.copy(c).addScaledVector(d, r);
      p.setXYZ(i, v.x, v.y, v.z);
      n.setXYZ(i, d.x, d.y, d.z);
    }
    p.needsUpdate = true; n.needsUpdate = true;
    return g;
  }
  // BoxGeometry-materiaalvolgorde: +X, -X, +Y, -Y, +Z, -Z  (tegenoverliggende kanten = 7)
  var FACE_VALUES = [2, 5, 1, 6, 3, 4];
  function makeDie(THREE, geo, body, pip) {
    var mats = FACE_VALUES.map(function (v) {
      var tex = new THREE.CanvasTexture(faceCanvas(v, body, pip));
      if ('colorSpace' in tex) tex.colorSpace = THREE.SRGBColorSpace;
      tex.anisotropy = 4;
      return new THREE.MeshStandardMaterial({ map: tex, roughness: .38, metalness: 0 });
    });
    var m = new THREE.Mesh(geo, mats);
    m.castShadow = true; m.receiveShadow = false;
    return m;
  }
  function faceCanvas(v, body, pip) {
    var s = 256, c = document.createElement('canvas'); c.width = c.height = s;
    var x = c.getContext('2d');
    x.fillStyle = body; x.fillRect(0, 0, s, s);
    var P = { 1: [[.5, .5]], 2: [[.28, .28], [.72, .72]], 3: [[.27, .27], [.5, .5], [.73, .73]],
      4: [[.28, .28], [.72, .28], [.28, .72], [.72, .72]], 5: [[.27, .27], [.73, .27], [.5, .5], [.27, .73], [.73, .73]],
      6: [[.28, .25], [.72, .25], [.28, .5], [.72, .5], [.28, .75], [.72, .75]] }[v];
    var rad = v === 1 ? 30 : 22;
    P.forEach(function (q) {
      var cx = q[0] * s, cy = q[1] * s;
      var g = x.createRadialGradient(cx - rad * .3, cy - rad * .3, rad * .1, cx, cy, rad);
      g.addColorStop(0, shade(pip, 18)); g.addColorStop(1, pip);
      x.fillStyle = g; x.beginPath(); x.arc(cx, cy, rad, 0, Math.PI * 2); x.fill();
      x.strokeStyle = 'rgba(0,0,0,.12)'; x.lineWidth = 2; x.stroke();
    });
    return c;
  }
  function shade(hex, amt) {
    var n = parseInt(hex.slice(1), 16), r = Math.min(255, (n >> 16) + amt), g = Math.min(255, ((n >> 8) & 255) + amt), b = Math.min(255, (n & 255) + amt);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }
  // kwaternion die waarde v naar boven (+Y) draait, plus draaiing om de verticale as
  function faceQuat(THREE, v, yaw) {
    var e = { 1: [0, 0, 0], 6: [Math.PI, 0, 0], 2: [0, 0, Math.PI / 2], 5: [0, 0, -Math.PI / 2], 3: [-Math.PI / 2, 0, 0], 4: [Math.PI / 2, 0, 0] }[v];
    var qf = new THREE.Quaternion().setFromEuler(new THREE.Euler(e[0], e[1], e[2]));
    var qy = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), yaw || 0);
    return qy.multiply(qf);
  }

  /* ---------- reserve: 2D-dobbelstenen als WebGL niet beschikbaar is ---------- */
  function Stage2D(el) {
    el.classList.add('is-2d');
    el.innerHTML = '<div class="g3d__die2d" data-d></div><div class="g3d__die2d g3d__die2d--dark" data-d></div>';
    var dice = el.querySelectorAll('[data-d]');
    function paint(d, v) {
      var L = { 1: [5], 2: [1, 9], 3: [1, 5, 9], 4: [1, 3, 7, 9], 5: [1, 3, 5, 7, 9], 6: [1, 3, 4, 6, 7, 9] }[v];
      d.innerHTML = '';
      for (var i = 1; i <= 9; i++) { var p = document.createElement('i'); if (L.indexOf(i) > -1) p.className = 'on'; d.appendChild(p); }
    }
    paint(dice[0], 1); paint(dice[1], 3);
    this.resize = function () {}; this.idle = function () {}; this.pause = function () {};
    this.roll = function (values) {
      return new Promise(function (res) {
        dice.forEach(function (d) { d.classList.add('is-rolling'); });
        var n = 0, iv = setInterval(function () {
          dice.forEach(function (d) { paint(d, 1 + Math.floor(Math.random() * 6)); });
          if (++n > 12) { clearInterval(iv); dice.forEach(function (d, i) { d.classList.remove('is-rolling'); paint(d, values[i]); }); res(); }
        }, 90);
      });
    };
  }

  /* ---------- start ---------- */
  if (isEditor) { if (cfg.show_in_editor) open(); return; }
  if (/[?&]g3d=reset/.test(location.search)) { st = {}; save(st); }
  if (suppressed()) return;
  setTimeout(open, Math.max(0, (cfg.delay || 2) * 1000));
})();
